import { tns } from 'tiny-slider/src/tiny-slider';

class BlockSlider {
	constructor(el) {
		this.el = el;

        const sliderContainer = this.el.querySelector('.block-slider__slider');
        const navContainer = this.el.querySelector('.block-slider__nav-container');

        const blockSlider = tns({
            container: sliderContainer,
            controls: false,
            autoHeight: true,
            axis: 'horizontal',
            swipeAngle: false,
            speed: 400,
            rewind: true,
            navContainer: navContainer,
            mouseDrag: true,
            slideBy: 'page',
            items: 1,
            edgePadding: 65,
            responsive: {
                768: {
                    items: 2,
                    edgePadding: 0
                },
                1024: {
                    items: 4,
                    edgePadding: 0
                }
            }
        });
    }
}

export default BlockSlider;
